<template>
  <div>
    <div v-if="mark" class="grading">
      <span
        v-tooltip="{ title: $t('studea_manager.dashboard.go_to_questionnaire') }"
        class="questionnaire__note"
        @click="goToQuestionnaire"
      >
        {{ mark }}
      </span>
    </div>
    <div v-else class="grading">
      <span
        v-tooltip="{ title: $t('studea_manager.dashboard.go_to_questionnaire') }"
        class="questionnaire__note"
        @click="goToQuestionnaire"
      >
        <FontAwesomeIcon icon="fa-light fa-hourglass-start" />
      </span>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "AccordionMarkSummarySheetComponent",
  props: {
    mark: {
      type: String,
      required: false,
      default: "",
    },
    questionnaire: {
      type: Object,
      required: true,
    },
    triad: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToQuestionnaire() {
      router.push({
        name: "questionnaire",
        params: {
          triadId: this.triad.id,
          questionnaireId: this.questionnaire.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.grading {
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px;
  margin-bottom: 5px;
  min-height: 21px;
}

.questionnaire__note {
  cursor: pointer;
}
</style>
